import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { companyAuthStatusApiClient } from '@src/api/company/auth/companyAuthStatusApiClient';
import { tenantAuthStatusApiClient } from '@src/api/tenant/auth/tenantAuthStatusApiClient';

import { CompanyUserProfile } from './types/CompanyUserProfile';
import { TenantUserProfile } from './types/TenantUserProfile';

export const fetchTenantUserProfile = async (
  setProfile: React.Dispatch<React.SetStateAction<TenantUserProfile | undefined>>,
) => {
  const res = await tenantAuthStatusApiClient.status();
  handleApiResponse(
    res,
    (data) => {
      setProfile({
        isLogin: data.is_login,
        user: data.user
          ? {
              id: data.user.id,
              familyName: data.user.family_name,
              firstName: data.user.first_name,
              avatarUrl: data.user.avatar_url,
              isAdmin: data.user.is_admin,
              enabled: data.user.enabled,
              role: {
                code: data.user.role.code,
              },
            }
          : undefined,
        tenant: data.tenant
          ? {
              service: {
                enterprise_portal: data.tenant.service.enterprise_portal,
                dx_diagnosis: data.tenant.service.dx_diagnosis,
                online_community: data.tenant.service.online_community,
              },
            }
          : undefined,
        topPageLink: data.top_page_link || '',
        firstViewLink: data.first_view_link || '',
      });
    },
    () => {
      setProfile({
        isLogin: false,
        user: undefined,
        tenant: undefined,
        topPageLink: '',
        firstViewLink: '',
      });
    },
  );

  if (res.result !== 'success') {
    setProfile({
      isLogin: false,
      user: undefined,
      tenant: undefined,
      topPageLink: '',
      firstViewLink: '',
    });
  }
};

export const fetchCompanyUserProfile = async (
  setProfile: React.Dispatch<React.SetStateAction<CompanyUserProfile | undefined>>,
) => {
  const res = await companyAuthStatusApiClient.status();
  handleApiResponse(
    res,
    (data) => {
      setProfile({
        isLogin: data.is_login,
        user: data.user
          ? {
              id: data.user.id,
              familyName: data.user.family_name,
              firstName: data.user.first_name,
              avatarUrl: data.user.avatar_url,
              isAdmin: data.user.is_admin,
              enabled: data.user.enabled,
              role: {
                code: data.user.role.code,
              },
            }
          : undefined,
        company: data.company
          ? {
              name: data.company.name,
            }
          : undefined,
        tenant: data.tenant
          ? {
              requiredUserApproval: data.tenant.required_user_approval,
              service: {
                dx_diagnosis: data.tenant.service.dx_diagnosis,
                enterprise_portal: data.tenant.service.enterprise_portal,
                online_community: data.tenant.service.online_community,
              },
            }
          : undefined,
        topPageLink: data.top_page_link || '',
        displayNameStatus: data.display_name_status,
      });
    },
    () => {
      setProfile({
        isLogin: false,
        user: undefined,
        company: undefined,
        tenant: undefined,
        topPageLink: '',
        displayNameStatus: { requires_display_name_update: false },
      });
    },
  );

  if (res.result !== 'success') {
    setProfile({
      isLogin: false,
      user: undefined,
      company: undefined,
      tenant: undefined,
      topPageLink: '',
      displayNameStatus: { requires_display_name_update: false },
    });
  }
};
